
import { format } from "date-fns";
import { fr } from "date-fns/locale";

// Format type name
export const getActivityTypeName = (type: string) => {
  const typeMap: Record<string, string> = {
    'irrigation': 'Irrigation',
    'fertilization': 'Fertilisation',
    'weather': 'Météo',
    'harvest': 'Récolte',
    'planting': 'Plantation',
    'maintenance': 'Maintenance',
    'inspection': 'Inspection',
    'other': 'Autre'
  };
  return typeMap[type] || 'Autre';
};

// Format reminder time
export const getReminderLabel = (reminder: string) => {
  const reminderMap: Record<string, string> = {
    '15min': '15 minutes avant',
    '30min': '30 minutes avant',
    '1hour': '1 heure avant',
    '2hours': '2 heures avant',
    '6hours': '6 heures avant',
    '12hours': '12 heures avant',
    '1day': '1 jour avant',
    '2days': '2 jours avant'
  };
  return reminderMap[reminder] || 'Aucun rappel';
};

// Format date
export const formatActivityDate = (dateString: string | Date): string => {
  return format(new Date(dateString), 'EEEE d MMMM yyyy', { locale: fr });
};

// Format time
export const formatActivityTime = (dateString: string | Date): string => {
  return format(new Date(dateString), 'HH:mm');
};
